(function () {
  // Protección básica: sin clic derecho ni arrastrar imágenes
  document.addEventListener('contextmenu', function (e) { if (e.target.closest('img, .print-mat, .hg-frame, .bundle-thumb')) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });

  // Encabezado al hacer scroll
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  // Aparición suave de las láminas
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  window.ffReveal = function (scope) {
    (scope || document).querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el, i) {
      if (!revealIO) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = (i % 3) * 90 + 'ms';
      revealIO.observe(el);
    });
  };
  window.ffReveal();

  // Menú móvil
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
  }

  // Galería: carga más láminas al bajar
  var grid = document.querySelector('[data-infinite-grid]');
  var loader = document.querySelector('[data-infinite-next]');
  if (grid && loader && 'IntersectionObserver' in window) {
    var loading = false;
    loader.querySelector('a').style.visibility = 'hidden';
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading) return;
      var next = loader.getAttribute('data-infinite-next');
      if (!next) return;
      loading = true;
      fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-infinite-grid]');
        if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (el) { grid.appendChild(el); });
        window.ffReveal(grid);
        var newLoader = doc.querySelector('[data-infinite-next]');
        if (newLoader) { loader.setAttribute('data-infinite-next', newLoader.getAttribute('data-infinite-next')); loading = false; }
        else { io.disconnect(); loader.remove(); }
      }).catch(function () { loader.querySelector('a').style.visibility = 'visible'; io.disconnect(); });
    }, { rootMargin: '600px 0px' });
    io.observe(loader);
  }

  // Desplegable de categorías: cerrar al hacer clic fuera
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-drop][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  // Arma tu set de 3
  document.querySelectorAll('[data-bundle]').forEach(function (root) {
    var picks = [];
    var items = root.querySelectorAll('.bundle-item');
    var slots = root.querySelectorAll('[data-slot]');
    var addBtn = root.querySelector('[data-bundle-add]');
    var priceEl = root.querySelector('[data-bundle-price]');
    var countEl = root.querySelector('[data-count]');
    if (!addBtn) return;
    function current() { return root.querySelector('input[name="bundle-variant"]:checked'); }
    function render() {
      items.forEach(function (it) {
        var i = picks.indexOf(it);
        it.classList.toggle('is-picked', i > -1);
        it.classList.toggle('is-full', picks.length >= 3);
        var chk = it.querySelector('.bundle-check'); if (chk) chk.setAttribute('data-n', i > -1 ? i + 1 : '');
      });
      slots.forEach(function (s, i) {
        var it = picks[i];
        s.classList.toggle('is-filled', !!it);
        s.style.backgroundImage = it ? 'url(' + it.getAttribute('data-img') + ')' : '';
      });
      if (countEl) countEl.textContent = picks.length;
      var v = current(); if (priceEl && v) priceEl.textContent = v.getAttribute('data-price');
      addBtn.disabled = picks.length !== 3;
    }
    items.forEach(function (it) {
      it.addEventListener('click', function () {
        var i = picks.indexOf(it);
        if (i > -1) picks.splice(i, 1); else if (picks.length < 3) picks.push(it);
        render();
      });
    });
    root.querySelectorAll('input[name="bundle-variant"]').forEach(function (r) { r.addEventListener('change', render); });
    addBtn.addEventListener('click', function () {
      var v = current(); if (!v || picks.length !== 3) return;
      var props = {};
      picks.forEach(function (it, i) { props['Lámina ' + (i + 1)] = it.getAttribute('data-pick'); });
      addBtn.disabled = true; addBtn.textContent = 'Agregando…';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(v.value), quantity: 1, properties: props }] })
      }).then(function (r) { if (!r.ok) throw new Error(); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Intenta de nuevo'; });
    });
    render();
  });

  // Ofertas en el carrito: 3 iguales = set, combinación de 3 = código de descuento
  var offers = document.querySelector('[data-cart-offers]');
  if (offers) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var setIds = { 'Sin marco': offers.getAttribute('data-set-sin-marco'), 'Marco negro': offers.getAttribute('data-set-marco-negro') };
    var comboCode = offers.getAttribute('data-combo-code');
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var units = { 'Sin marco': [], 'Marco negro': [] };
      cart.items.forEach(function (it) {
        if (it.product_type !== 'Lámina') return;
        var t = it.variant_title;
        if (!units[t]) return;
        for (var q = 0; q < it.quantity; q++) units[t].push(it);
      });
      var updates = {}, adds = [];
      Object.keys(units).forEach(function (t) {
        var list = units[t];
        if (!setIds[t]) return;
        while (list.length >= 3) {
          var three = list.splice(0, 3), props = {};
          three.forEach(function (it, i) {
            props['Lámina ' + (i + 1)] = it.product_title;
            updates[it.key] = (updates[it.key] !== undefined ? updates[it.key] : it.quantity) - 1;
          });
          adds.push({ id: Number(setIds[t]), quantity: 1, properties: props });
        }
      });
      if (adds.length) {
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: adds }) }); })
          .then(function () { sessionStorage.setItem('ff-set-note', '1'); window.location.reload(); });
      }
      try { if (sessionStorage.getItem('ff-set-note')) { var n = document.querySelector('[data-set-note]'); if (n) n.hidden = false; sessionStorage.removeItem('ff-set-note'); } } catch (e) {}
      var left = units['Sin marco'].length + units['Marco negro'].length;
      if (left >= 3 && comboCode) {
        var note = document.querySelector('[data-combo-note]'); if (note) note.hidden = false;
        var btn = document.querySelector('[data-checkout]');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault();
          window.location.href = root + 'discount/' + encodeURIComponent(comboCode) + '?redirect=' + encodeURIComponent(root + 'checkout');
        });
      }
    }).catch(function () {});
  }

  // Pasillo de museo: caminar al hacer scroll y mirar con el mouse
  (function () {
    var halls = document.querySelectorAll('[data-hall]');
    if (!halls.length) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function walk() {
      halls.forEach(function (h) {
        var sc = h.querySelector('[data-hall-scene]'); if (!sc) return;
        var r = h.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -r.top / r.height));
        var D = parseFloat(getComputedStyle(h).getPropertyValue('--D')) || 1500;
        sc.style.transform = 'translateZ(' + (p * D * 0.45).toFixed(1) + 'px)';
      });
    }
    if (!still) {
      window.addEventListener('scroll', walk, { passive: true }); walk();
      halls.forEach(function (h) {
        h.addEventListener('mousemove', function (e) {
          var r = h.getBoundingClientRect();
          var x = 50 + ((e.clientX - r.left) / r.width - .5) * 10;
          var y = 46 + ((e.clientY - r.top) / r.height - .5) * 6;
          h.style.perspectiveOrigin = x.toFixed(1) + '% ' + y.toFixed(1) + '%';
        });
        h.addEventListener('mouseleave', function () { h.style.perspectiveOrigin = ''; });
      });
    }
    window.ffHallWalk = walk;
  })();

  // Pasillo: al hacer clic, bajar a los cuadros de la sala
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-hall]'); if (!h) return;
    var sec = h.closest('section') || document;
    var g = sec.querySelector('.grid, [data-sala-grid]'); if (!g) return;
    var top = g.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  // Carrito: actualiza al cambiar cantidad
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var btn = document.querySelector('[data-cart-update]');
      if (btn) btn.click();
    });
  });

  // Producto: selector de tamaño / marco
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var mainImg = root.querySelector('.main-image');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var currency = root.getAttribute('data-currency') || 'MXN';
    var fmt = new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
    var money = function (cents) { return fmt.format(cents / 100); };

    var mainFrame = root.querySelector('[data-main-frame]');
    function setImage(src, isArte) {
      if (!mainImg || !src) return;
      if (mainFrame) mainFrame.classList.toggle('is-arte', !!isArte);
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
    }

    function update(fromUser) {
      var selected = groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
      groups.forEach(function (g, i) {
        var label = g.querySelector('[data-option-value]');
        if (label) label.textContent = selected[i];
      });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'No disponible';
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      if (fromUser && variant.featured_image) setImage(variant.featured_image.src, false);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    if (groups.length) update(false);

    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        setImage(btn.getAttribute('data-src'), btn.hasAttribute('data-arte'));
      });
    });
  });
})();
